import { render, staticRenderFns } from "./SendFeedback.vue?vue&type=template&id=b3418b7e"
import script from "./SendFeedback.vue?vue&type=script&lang=ts"
export * from "./SendFeedback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports